export default __webpack_public_path__ + "static/media/Kitchen_V.4.7150ec89.png";